import { gql } from 'graphql-tag';

export enum FormCategoryId {
  SPEAK_UP = '00000000-0000-0000-0000-000000000502',
  CONFLICT_OF_INTEREST = '00000000-0000-0000-0000-000000000501',
}

export const GET_FORM_CATEGORIES = gql`
  query GetFormCategories {
    formCategories {
      formCategories {
        id
        categoryKey
        label
        description
        isActive
      }
      count
    }
  }
`;
